const removeTimezoneFromISOStringDate = (date: string) => {
    const newDate = new Date(date);
    const removedTimezone = new Date(newDate?.getTime() - newDate?.getTimezoneOffset() * 60000);

    return removedTimezone.toISOString();
};

export default removeTimezoneFromISOStringDate;
